import { App, Button, Card, Col, Popconfirm, Row, Space, Table, Tag } from "antd";
import React, { useEffect, useState } from "react";
import { LEANER_WATCHTIME, USER_INFO } from "../apis/apis";
import CulsightPageLoader from "../components/CulsightPageLoader";
import { EMPTY_LEADERBOARD, UPDATE_LEADERBOARD } from "../apis/LeaderBoardApi";


function Dashboard() {
  const { notification } = App.useApp();
  const [loader, setLoader] = useState(false);
  const [user_info, set_user_info] = useState({});
  const [learner_watch, set_learner_watch] = useState([]);
  useEffect(() => {
    const LIST_API = async () => {
      setLoader(true);
      const FORM_DATA = new FormData();
      try {
        const API_CALL = await USER_INFO(FORM_DATA);
        if (API_CALL?.data?.status) {
          set_user_info(API_CALL?.data);
        } else {

        }
      } catch (error) {

      } finally {
      }
    };
    const LEANER_WATCHTIME_API = async () => {
      const FORM_DATA = new FormData();
      try {
        const API_CALL = await LEANER_WATCHTIME(FORM_DATA);
        if (API_CALL?.data?.status) {
          set_learner_watch(API_CALL?.data?.learners);
        } else {

        }
      } catch (error) {

      } finally {
        setLoader(false);
      }
    };


    LIST_API();
    LEANER_WATCHTIME_API()
  }, []);


  const columns = [
    {
      title: "Rank",
      dataIndex: "rank",
      render: (text, record) => (
        <span>
          {record.rank}
        </span>
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      render: (text, record) => (
        <span>
          {record.first_name} {record.last_name}
        </span>
      ),
    },
    {
      title: "Time Spent",
      dataIndex: "name",
      render: (text, record) => (
        <span>
          {formatTime(record.total_max_watched)}
        </span>
      ),
    },
  ];
  const formatTime = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60); // round down

    const h = hrs > 0 ? `${String(hrs).padStart(2, "0")}h ` : "";
    const m = mins > 0 ? `${String(mins).padStart(2, "0")}m ` : "";
    const s = `${String(secs).padStart(2, "0")}s`;

    return h + m + s;
  };
  const UPDATE_LEADERBOARD_API = async () => {
    const FORM_DATA = new FormData();
    try {
      const API_CALL = await UPDATE_LEADERBOARD(FORM_DATA);
      if (API_CALL?.data?.status) {
        notification.success({
          message: "Successful",
          description: API_CALL.data.message,
        });
      } else {

      }
    } catch (error) {

    } finally {
      setLoader(false);
    }
  };
  const EMPTY_LEADERBOARD_API = async () => {
    const FORM_DATA = new FormData();
    try {
      const API_CALL = await EMPTY_LEADERBOARD(FORM_DATA);
      if (API_CALL?.data?.status) {
        notification.success({
          message: "Successful",
          description: API_CALL.data.message,
        });
      } else {

      }
    } catch (error) {

    } finally {
      setLoader(false);
    }
  };

  return (
    <div className="lms-body">
      <Card>
        {loader ? <>
          <CulsightPageLoader />
        </> : <>
          <h2>Dashboard</h2>

          <Row gutter={[10, 10]} style={{ marginBottom: "10px" }}>
            {/* Total Users */}
            <Col lg={8} md={12} sm={24} xs={24}>
              <Card className="dashboard-card">
                <h3 className="card-title">

                  Total Users
                  <span className="count-tag">
                    <Tag className="tag-number">

                      {user_info?.total_users ?? 0}
                    </Tag>
                  </span>
                </h3>

                <p >Number of users in system</p>
              </Card>

            </Col>

            {/* Active Users */}
            <Col lg={8} md={12} sm={24} xs={24}>
              <Card className="dashboard-card2">
                <h3 className="card-title">
                  Total Active Users{" "}
                  <span className="count-tag">
                    <Tag className="tag-number2">

                      {user_info?.active_users ?? 0}
                    </Tag>
                  </span>
                </h3>
                <p>Number of active users in system</p>
              </Card>
            </Col>

            {/* Inactive Users */}
            <Col lg={8} md={12} sm={24} xs={24}>
              <Card className="dashboard-card">
                <h3 className="card-title">
                  Total Inactive Users{" "}
                  <span className="count-tag">
                    <Tag className="tag-number3">

                      {user_info?.inactive_users ?? 0}
                    </Tag>
                  </span>
                </h3>
                <p>Number of inactive users in system</p>
              </Card>
            </Col>

            <Col xs={24} lg={14}>
              <Card>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "15px",
                    gap: "10px",
                    flexWrap: "wrap",
                  }}
                >
                  <h2 style={{ margin: 0,flex: 1,minWidth: "250px",}}>Leaderboard - Top 10 Learners</h2>

                  <Space wrap>
                    <Popconfirm
                      title="Refresh Leaderboard"
                      description="Are you sure you want to refresh the leaderboard?"
                      onConfirm={UPDATE_LEADERBOARD_API}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Button type="primary" size="small">
                        Refresh Leader Board
                      </Button>
                    </Popconfirm>

                    <Popconfirm
                      title="Empty Leaderboard"
                      description="This will remove all leaderboard data. Are you sure?"
                      onConfirm={EMPTY_LEADERBOARD_API}
                      okText="Yes"
                      cancelText="No"
                      okButtonProps={{ danger: true }}
                    >
                      <Button danger type="primary" size="small">
                        Empty Leader Board
                      </Button>
                    </Popconfirm>
                  </Space>
                </div>

                <Table
                  columns={columns}
                  pagination={false}
                  dataSource={learner_watch}
                  scroll={{ x: "max-content" }}
                />
              </Card>
            </Col>


            {/* Pie Chart */}
            <Col xs={24} lg={12}>
              {/* <Button onClick={() => update_db_Api()}>UPDATE_QUIZE_SETTING_DATA</Button> */}
            </Col>
          </Row>
        </>}


      </Card>
    </div>
  );
}

export default Dashboard;


